import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import JobCardLarge from '../job/JobCardLarge';
import AdNZWorksLarge from '../common/ads/AdNZWorksLarge';
import AdNZCafemap from '../common/ads/AdNZCafemap';

const latestJobListStyles = `
.latestJobList {
  margin-top: 2rem;
}
.latestJobList__item {
  display: block;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: box-shadow 0.2s;
  margin-bottom: 1.5rem;
  text-decoration: none;
}
.latestJobList__item:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
}
`;

const LatestJobList = props => {
    const { jobList } = props;
    const adCount = 3 - (jobList.length % 3);

    const renderAds = () => {
        switch (adCount) {
            case 2:
                return (
                    <Fragment>
                        <Grid item xs={12} sm={6} md={4}>
                            <AdNZWorksLarge />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <AdNZCafemap />
                        </Grid>
                    </Fragment>
                )
            case 1:
                return (
                    <Grid item xs={12} sm={6} md={4}>
                        <AdNZWorksLarge />
                    </Grid>
                )
            default:
                return null;
        }
    }

    return (
        <>
            <Grid container spacing={3}>
                {
                    !jobList || jobList.length === 0
                        ? (
                            <Grid item xs={12}>
                                <p>データがありません</p>
                            </Grid>
                        )
                        : jobList.map(job => (
                            <Grid item xs={12} sm={6} md={4} key={job._id}>
                                <Link to={`/jobs/${job._id}`} style={{ textDecoration: 'none' }}>
                                    <JobCardLarge job={job} />
                                </Link>
                            </Grid>
                        ))
                }
                {renderAds()}
            </Grid>
        </>
    )
}

LatestJobList.propTypes = {
    jobList: PropTypes.array
}

export default LatestJobList
